import { createFileRoute } from "@tanstack/react-router";
import HistorySharePage, {
  historyValidateSearch,
} from "../-share_pages/history/index";

export const Route = createFileRoute("/template_protections/history/sent")({
  validateSearch: historyValidateSearch,
  component: SentHistoryPage,
});

function SentHistoryPage() {
  return (
    <HistorySharePage
      type="send"
      routeId="/template_protections/history/sent"
    />
  );
}
